import { MatchHeight } from "@plugins";
import jquery from "jquery";

const $ = jquery;

$(document).ajaxSuccess(() => {
    initInstructionsMatchHeight();
});

window.addEventListener("load", initInstructionsMatchHeight());

function initInstructionsMatchHeight() {
    if (!window.mobileMedia) {
        const neededSelectors = ["[data-mh='instruction-title']", "[data-mh='instructions-all-item']"];

        for (const iterator of neededSelectors) {
            new MatchHeight(iterator);
        }
    }
}
